<template>
	<div>
		<div class="card mb-4">
            <div class="card-header">
		    	<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Informações</strong>
		            </div>
			    </div>
		    </div>
		    <div class="card-body">
		    	<div class="container-fluid">
					<div class="text-muted fs-17 mb-2 ml-2">
				        <strong>Produto</strong>
				    </div>
					<div class="row">
						<div class="col-xl-6 col-md-6 mb-4">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Nome</strong>
									</div>
									<div v-html="dados.produto"></div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Estágio</strong>
									</div>
									<div v-html="dados.estagio_badge"></div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Quantidade</strong>
									</div>
									<div>
										{{ dados.quantidade }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Custo de Produção</strong>
									</div>
									<div>
										{{ getCustoProducao(dados) }}
									</div>
								</li>
							</ul>
						</div>
						<div class="col-xl-6 col-md-6 mb-4">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between" v-if="dados.estagio_id >= 2">
									<div>
										<strong>Finalizados</strong>
									</div>
									<div>
										{{ dados.quantidade_finalizada }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Valor</strong>
									</div>
									<div>
										{{ formatarValor(dados.valor) }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Desconto</strong>
									</div>
									<div>
										{{ formatarValor(dados.desconto) }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Total</strong>
									</div>
									<div>
										R$ {{ dados.valor_total }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Percentual de Lucro</strong>
									</div>
									<div>
										{{ formatarPercentual(dados.percentual_lucro) }}
									</div>
								</li>
							</ul>
						</div>
					</div>
		    		<div class="row mt-4" v-if="dados.descricao">
					    <div class="col-md-12">
					    	<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Descrição</strong>
				            </div>
							<div class="card">
  								<div class="card-body" v-html="dados.descricao"></div>
							</div>
					    </div>
					</div>
					<div class="row mt-4" v-if="dados.estagio_id > 1">
					    <div class="col-md-12">
					    	<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Progresso</strong>
				            </div>
					        <ul class="list-group">
		    					<li class="list-group-item">
									<div v-html="dados.progress_bar"></div>
								</li>
							</ul>
					    </div>
					</div>
				</div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados'],
		methods: {
			getCustoProducao(dados){
				let custoTotal = 0;
				for(let i in dados.materiais){
					custoTotal += dados.materiais[i].valor_por_produto * dados.quantidade;
				}
				return this.formatarValor(custoTotal);
			},
			formatarValor(valor) {
				return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
			},
			formatarPercentual(percentual) {
				return percentual.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).replace(/\./g, '') + '%';
			}
		}
	}
</script>
